import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Button, Text, VStack } from "@chakra-ui/react"
import { FaKeyboard } from "react-icons/fa"

export function FlashcardShortcutsModal({
  compact = false,
}: {
  compact?: boolean
}) {
  return (
    <DialogRoot lazyMount size={{ base: "xs", md: "md" }} placement="center">
      <DialogTrigger asChild>
        <Button
          aria-label="Keyboard shortcuts"
          colorPalette="teal"
          fontSize="xs"
          fontWeight="semibold"
          h={compact ? "32px" : "auto"}
          minH="unset"
          px={2}
          py={compact ? 0 : 1}
          size="xs"
          variant="outline"
        >
          <FaKeyboard data-testid="keyboard-shortcuts-icon" />
          {!compact && "Shortcuts"}
        </Button>
      </DialogTrigger>
      <DialogContent maxW="lg">
        <DialogHeader>
          <DialogTitle>Keyboard shortcuts</DialogTitle>
        </DialogHeader>
        <DialogCloseTrigger />
        <DialogBody>
          <VStack gap={3} align="stretch">
            <Text>
              <strong>Space</strong> — show answer
            </Text>
            <Text>
              <strong>1–5</strong> — rate the card and move to the next
            </Text>
            <Text>
              <strong>B</strong> — bookmark this card or add a note
            </Text>
            <Text>
              <strong>S</strong> — save the bookmark or note
            </Text>
          </VStack>
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  )
}
